import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "security-guards-sydney";
const serviceId = 1;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Security Guards Sydney | Ozy Wide Group",
    description:
      "Licensed security officers for businesses, sites, events, residential properties and public-facing premises.",
    keywords:
      "security guards Sydney, licensed security officers, event security, business security, residential security, site security",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Security Guards",
    description:
      "Licensed security officers for businesses, sites, events, residential properties and public-facing premises.",
    points: createServicePoints(
      "Site duties and risks scoped first",
      "Licensed guard support matched to the role",
      "Reporting and escalation set clearly",
    ),
    images: createImageItems(images, "Security Guards Sydney"),
    content,
  };
